import { appName } from "../app.info";
const storageId = appName + "_localstorage_";
/** Legacy standalone dealers app key (pre ATP_DEALERS rename). */
const LEGACY_AUTH_KEY = "WFAC_localstorage_auth";

export const set = (e) => {
  const { key, data } = e;
  const jsonData = JSON.stringify(data);
  if (e) {
    localStorage.setItem(`${storageId}${key}`, jsonData);
  }
};
export const get = (e) => {
  const { key, data } = e;
  const jsonData = localStorage.getItem(`${storageId}${key}`);
  // console.log"local storage get", JSON.parse(jsonData));
  return JSON.parse(jsonData);
};
export const remove = (e) => {
  const { key, data } = e;
  localStorage.removeItem(`${storageId}${key}`);
};

/** Safe auth blob from current (or legacy) localStorage key. */
export const getAuth = () => {
  try {
    const data = get({ key: "auth" });
    if (data && typeof data === "object" && data.token) return data;
    const legacyRaw = localStorage.getItem(LEGACY_AUTH_KEY);
    if (legacyRaw) {
      const legacy = JSON.parse(legacyRaw);
      if (legacy && typeof legacy === "object") return legacy;
    }
    return data && typeof data === "object" ? data : {};
  } catch {
    return {};
  }
};

export const getAuthUserId = () => {
  const auth = getAuth();
  return auth.id || (auth.user && auth.user.id) || "";
};
